import React from 'react';
import { connect } from 'react-redux';
import { selectNonPinnedVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { Variables } from '../variables/Variables';

const _NonPinnedVariablesGrid = ({ nonPinnedVariables }: Props) => (
    <Variables variables={nonPinnedVariables} />
);

type Props = {
    nonPinnedVariables: GiftJson.Variable<any>[];
};

const mapStateToProps = (state: GiftPdpState) => ({
    nonPinnedVariables: selectNonPinnedVariables(state)
});

export const NonPinnedVariables = connect(
    mapStateToProps
)(_NonPinnedVariablesGrid);